import { useCallback, useEffect, useRef, useState } from "react";
import useAsyncCallback from "./useAsyncCallback";

interface ISearchOptions {
    noLimit?: boolean;
    cache?: boolean;
    inicial?: string;
}

export function useSearch<T>(
    controller: (searchValue: string) => Promise<Array<T>>,
    options?: ISearchOptions
) {
    const [lstSearchResult, setLstSearchResult] = useState<Array<T>>([]);
    const { loading, execute } = useAsyncCallback(controller, []);

    const ultimaPesquisaRef = useRef("");
    const cacheMap = useRef<Map<string, Array<T>>>(new Map());

    const handleSearch = useCallback(
        (searchValue: string) => {
            ultimaPesquisaRef.current = searchValue;

            if (searchValue.length >= 3 || options?.noLimit) {
                setTimeout(() => {
                    if (options?.cache && cacheMap.current.has(searchValue)) {
                        setLstSearchResult(
                            cacheMap.current.get(searchValue) ?? []
                        );
                    } else if (ultimaPesquisaRef.current === searchValue) {
                        execute(searchValue).then((res) => {
                            if (options?.cache)
                                cacheMap.current.set(searchValue, res);
                            setLstSearchResult(res);
                        });
                    }
                }, 1000);
            }
        },
        [execute, options?.cache, options?.noLimit]
    );

    useEffect(() => {
        if (options?.inicial !== undefined) handleSearch(options?.inicial);
    }, [options?.inicial, handleSearch]);

    return {
        loading,
        value: lstSearchResult,
        handleSearch,
    };
}
